import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { Link, Navigate, useParams } from "react-router-dom";
import { fetchBlogs } from "../data/blogs";
import { withImageVersion } from "../contextApi/ImageVersionContext";
import "../styles/blogs.css";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const blogs = await fetchBlogs();
        const found = blogs.find((item) => item.slug === slug);
        if (found) {
          setBlog(found);
        }
      } catch (error) {
        console.log("error:", error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  if (loading) {
    return (
      <main className="blogs-page">
        <div className="blogs-container">Loading...</div>
      </main>
    );
  }

  if (!blog) {
    return <Navigate to="/Blogs" replace />;
  }

  return (
    <main className="blogs-page">
      <div className="blogs-container">
        <Link className="blog-back-link" to="/Blogs">
          Back to blogs
        </Link>

        <section className="blog-detail-hero">
          <img className="blog-detail-image" src={withImageVersion(blog.image)} alt={blog.title} />
          <div>
            {blog.category && <div className="blog-category" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.category) }} />}
            <h1 className="blog-detail-title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.title) }} />
            <div className="blog-meta">
              {/* <span className="blog-author">{blog.author}</span> */}
              <span> {blog.date} </span>
            </div>
            <p className="blog-detail-copy" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.excerpt) }} />
          </div>
        </section>

        <article>
          {blog.details.map((paragraph, index) => (
            <div
              className="blog-detail-copy"
              key={`${blog.slug}-detail-${index}`}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(paragraph) }}
            />
          ))}
        </article>
      </div>
    </main>
  );
};

export default BlogDetails;
